import * as ajax from '@/api/common'
import wechat from '@/libs/wechat'

/**
 * 拉起微信「商家转账 - 用户确认收款」页面
 *
 * v3 商家转账是「用户确认收款」模式：发起转账只完成受理，必须由收款人本人在微信内
 * 确认才会到账，24 小时不确认会自动退回。
 *
 * 流程：
 *   ① 向服务端取参 /Pay/transferPackage（服务端会先查单，确认单据仍在待确认状态，
 *      避免对已到账/已关闭的单据拉起确认页）
 *   ② 按「当前页面地址」重新取 JS-SDK 签名（全局路由也做过签名，但它的 jsApiList
 *      不含 requestMerchantTransfer，所以这里必须重签一次）
 *   ③ wx.config 把 requestMerchantTransfer 加入 jsApiList
 *   ④ 通过 WeixinJSBridge.invoke 调起确认页
 *
 * 依据：https://pay.weixin.qq.com/doc/v3/merchant/4012716430
 *   公众号 H5 没有 wx.requestMerchantTransfer，必须用 WeixinJSBridge.invoke。
 *
 * @param {Object} params 取参入参：{ kind: 'withdraw' | 'orderpay', id }
 * @param {Object} cbs    回调：{ onSuccess, onCancel, onError, onDone }
 *                        onSuccess —— 确认页正常返回（**不代表已到账**，到账以服务端回调为准）
 *                        onCancel  —— 用户取消
 *                        onError   —— 取参/签名/调起失败，参数为提示文案
 *                        onDone    —— 无论成败都会执行，用于收起 loading
 */
export function confirmReceipt (params, cbs) {
  const opt = cbs || {}
  const data = Object.assign({ showTips: false, showLoading: true }, params)
  ajax.post('/Pay/transferPackage', data)
    .then(payload => {
      pullUp(payload, opt)
    })
    .catch(e => {
      if (opt.onError) opt.onError((e && e.msg) || '获取收款信息失败')
      if (opt.onDone) opt.onDone()
    })
}

function pullUp (payload, opt) {
  const signUrl = window.location.href.split('#')[0]
  ajax.get('/Publics/getWxSign', { input_url: signUrl, showTips: false, showLoading: false })
    .then(sign => {
      wx.config({
        debug: false,
        appId: sign.appId,
        timestamp: sign.timestamp,
        nonceStr: sign.nonceStr,
        signature: sign.signature,
        jsApiList: ['checkJsApi', 'requestMerchantTransfer']
      })
      wx.error(() => {
        if (opt.onError) opt.onError('微信授权失败，请刷新页面后重试')
        if (opt.onDone) opt.onDone()
      })
      wechat.requestMerchantTransfer(
        payload,
        () => {
          if (opt.onSuccess) opt.onSuccess()
          if (opt.onDone) opt.onDone()
        },
        () => {
          if (opt.onCancel) opt.onCancel()
          if (opt.onDone) opt.onDone()
        },
        msg => {
          if (opt.onError) opt.onError(msg || '调起失败')
          if (opt.onDone) opt.onDone()
        }
      )
    })
    .catch(e => {
      if (opt.onError) opt.onError((e && e.msg) || '获取微信签名失败')
      if (opt.onDone) opt.onDone()
    })
}

export default { confirmReceipt }
